<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="70px">
            <el-form-item label="酒店名称" prop="hotelName">
                <el-input v-model="searchForm.hotelName" placeholder="请输入酒店名称" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="推广账号" prop="username">
                <el-input v-model="searchForm.username" placeholder="请输入推广账号" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="IP" prop="remoteIp">
                <el-input v-model="searchForm.remoteIp" placeholder="请输入IP" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="来源" prop="status">
                <el-select v-model="searchForm.scene" placeholder="请选择" style="width: 120px">
                    <el-option label="普通" :value="0"></el-option>
                    <el-option label="朋友圈分享" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间" prop="selectTime">
                <el-date-picker v-model="selectTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                    key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"  style="width: 230px"
                    @change="handleChangeDate"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column type="index" label="#" align="center" fixed="left"></el-table-column>
            <el-table-column prop="createTime" label="时间"></el-table-column>
            <el-table-column prop="scene" label="来源">
                <template slot-scope="{ row }">
                    <el-tag type="danger" v-if="row.scene == 0">普通</el-tag>
                    <el-tag v-else>朋友圈分享</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="hotelName" label="酒店名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="openId" label="用户OpenID"></el-table-column>
            <el-table-column prop="remoteIp" label="IP"></el-table-column>
            <el-table-column prop="username" label="来源归属用户"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
            style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
            :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchForm: {
                scene: 0,
                startDate: '',
                endDate: '',
                pageSize: 10,
                pageNumber: 1,
            },
            total: 0,
            tableData: [],
            isLoading: false,
            submitLoading: false,
            selectTime: null
        }
    },
    created() {
        this.getTableData();
    },
    methods: {
        handleChangeDate(date) {
            if (date.length) {
                this.searchForm.startDate = date[0];
                this.searchForm.endDate = date[1];
            }
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                scene: 0,
                startDate: '',
                endDate: '',
                pageSize: 10,
                pageNumber: 1,
            };
            this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/promotion/listForPage", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        }

    },
}
</script>
<style type="less">
@import url("./index.less");
</style>


